export enum Vloerverwarming {
    TACKERSYSTEEM = 'Tackersysteem',
    NETSYSTEEM = 'Netsysteem',
    NOPPENSYSTEEM = 'Noppensysteem',
    FERMACELL = 'Fermacell',
    BETONKERN_ACTIVERING = 'Betonkernactivering',
    DROOGSYSTEEM = 'Droogsysteem',
    INFREZEN = 'Infrezen',
}

export enum Klimaatwand {
    DROOG = 'Droog',
    NAT = 'Nat',
}

export enum Klimaatplafond {
    DROOG = 'Droog',
    NAT = 'Nat',
}

export interface S3File {
    key: string;
    url: string;
}

export interface ProjectSection {
    id: number;
    sectionName: string;
    sectionOrder: number;
    afgeperstMet: string;
    hoeveelheidDruk: number;
    buitenTemperatuur: number;
    plan: S3File | File | null;
    images: (S3File | File)[];
}

export interface Project {
    id: number;
    title: string;
    klant: string;
    adres: string;
    info: string;
    vloerverwarming: Vloerverwarming[];
    klimaatwand: Klimaatwand | null;
    klimaatplafond: Klimaatplafond | null;
    volgensLegplan: boolean;
    kringnummersAangegevenOpVerdelers: boolean;
    installatieDicht: boolean;
    sections: ProjectSection[];
}
